module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Roadmap-to-Oxbridge_Cover-404a58a4611c472c1dbe69c4737f82c6.jpg";